module.exports = __webpack_public_path__ + "static/media/climate_background_top_left.bb43e2f9.svg";